import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Replay } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { emailService } from '../../services/emailService';
import type { EmailLogEntry } from '../../types/email';

interface Props {
  log: EmailLogEntry;
  onResent: () => void;
}

/** Send a logged email again, written fresh for the record as it is now. */
const ResendEmailButton: React.FC<Props> = ({ log, onResent }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [busy, setBusy] = useState(false);

  const resend = async () => {
    setBusy(true);
    try {
      const queued = await emailService.resend(log._id);
      enqueueSnackbar(`Sending to ${queued.to.join(', ')}`, { variant: 'success' });
      onResent();
    } catch (err: any) {
      enqueueSnackbar(err?.message || 'Couldn’t send the email again', { variant: 'error' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="small" color={log.status === 'failed' ? 'primary' : 'inherit'} startIcon={<Replay sx={{ fontSize: 16 }} />}
      onClick={resend} disabled={busy || log.status === 'sending'}
      sx={{ textTransform: 'none', fontWeight: 600, whiteSpace: 'nowrap', color: log.status === 'failed' ? undefined : 'text.secondary' }}
    >
      {busy ? 'Sending…' : 'Resend'}
    </Button>
  );
};

export default ResendEmailButton;
